export default "__VITE_ASSET__ZlQg0jxL__"